// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"footer-module--sponsors--UVvBO","sponsorLogo":"footer-module--sponsorLogo--iRP9O","notice":"footer-module--notice--6wl5v"};